import './App.css';
import SearchField from "react-search-field";
import FeatherIcon from 'feather-icons-react';
import axios from 'axios';
import { useEffect, useState } from 'react';

function App() {
  const [city,setCity]=useState("");
  const [temp,setTemp]=useState(0);
  const [humidity,setHumdity]=useState(0);
  const [search,setSearch]=useState("Noida");
  const [pressure,setPressure]=useState("");
  const [wind,setWind]=useState("");
  // const [weaterdata,setWeatherdata]=useState([]);

  useEffect(()=>{
    axios.get(`https://api.openweathermap.org/data/2.5/weather?q=${search}&appid=70fd83ea45dc3ddd8463068455137e7f`).then((res)=>{
      console.log("res",res);
      setTemp(res.data.main.temp);
      setPressure(res.data.main.pressure);
      setCity(res.data.name);
      setHumdity(res.data.main.humidity
        );
      setWind(res.data.wind.speed);
    })
        


  },[search]);

  return (
    <div className="weather-box">
      <div className="weather-header">
        <h1>Weather-App</h1>  
      </div>
      <div className="weather-search">
       <SearchField
         placeholder="Search..."
         onSearchClick={(value)=>{
           setSearch(value)
         }}
         searchText=""
         classNames="test-class"
        />
      </div>
      <div className='weather-cloud'>
        <FeatherIcon icon="cloud-drizzle" color="red" size="60" />
      </div>
      <div className='weather-city'>
        <h1>{city}</h1>
      </div>
      <div className='weather-row1'>
        <div class Name='weather-column'>
          <FeatherIcon icon="sun" color="red" />
          <p>Temp : {(temp-273.15).toFixed(2)}"C</p>
        </div>
        <div className='weather-column'>
          <FeatherIcon icon="command" color="green"/>
          <p>Pressure : {pressure}</p>
        </div>
        
      </div>
      <div className='weather-row2'>
        <div className='weather-column'>
          <FeatherIcon icon="cloud" color="white" />
          <p>Humidity : {humidity}</p>
        </div>
        <div className='weather-column'>
          <FeatherIcon icon="wind" color="blue"/>
          <p>Wind : {wind}</p>
        </div>
        
      </div>
      
    </div>
  );
}

export default App;
